import { Icon } from "@iconify/react";

import sectionImage from "../public/assets/images/bg_home.png";

import { title, subtitle } from "@/components/primitives";

export const InfoSection = () => {
  return (
    <div className="flex ct-hero w-full justify-center md:mx-auto">
      <div className="md:container xl:columns-2 lg:columns-2 gap-4 mt-[80px]">
        <div className="lg:w-full xl:1/2 md:w-full sm:w-full ct-description p-3 sm:p-2 text-center break-after-column mb-8 w-full">
          <div className="lg:ct-image-container justify-center md:mx-auto ct-bg-primary rounded-md">
            <img alt="" className="w-full" src={sectionImage} />
          </div>
        </div>
        <div className="lg:w-full xl:1/2 md:w-full sm:w-full ct-transfer px-5 flex flex-wrap items-center flex-col justify-center">
          <div>
            <h3 className="my-2 text-start text-lg lg:text-xl text-default-600 font-semibold ct-text-primary">
              Why Choose CryptoTX?
            </h3>
            <h1 className={title({ fullWidth: false, size: "md" })}>
              Limitless means of sending money for businesses & individuals.
            </h1>
            <p className={subtitle({ class: "mt-7" })}>
              Whether you're paying for services, purchasing goods, or
              conducting business transactions, CryptoTX ensures your funds move
              effortlessly across borders, converting your USDT to local
              currency on the go!
            </p>
            <div className="flex justify-center mt-8 break-after-column gap-6">
              <ul className="gap-3 gap-lg-4">
                <li className="flex items-center gap-2 mb-3">
                  <Icon
                    className="ct-text-primary"
                    height="auto"
                    icon="material-symbols:check-circle-outline"
                  />
                  <span className="fs-six fw-medium n700-color">
                    Global Reach :{" "}
                    <span className="fs-seven fw-normal">
                      Send USDT to any bank account in the world.
                    </span>
                  </span>
                </li>
                <li className="flex items-center gap-2 mb-3">
                  <Icon
                    className="ct-text-primary"
                    height="auto"
                    icon="material-symbols:check-circle-outline"
                  />
                  <span className="fs-six fw-medium n700-color">
                    Instant Conversion :{" "}
                    <span className="fs-seven fw-normal">
                      Your crypto is converted to local currency swiftly.
                    </span>
                  </span>
                </li>
                <li className="flex items-center gap-2 mb-3">
                  <Icon
                    className="ct-text-primary"
                    height="auto"
                    icon="material-symbols:check-circle-outline"
                  />
                  <span className="fs-six fw-medium n700-color">
                    No Hidden Fees:{" "}
                    <span className="fs-seven fw-normal">
                      Transparent pricing, what you see is what you get.
                    </span>
                  </span>
                </li>
                <li className="flex items-center gap-2">
                  <Icon
                    className="ct-text-primary"
                    height="auto"
                    icon="material-symbols:check-circle-outline"
                  />
                  <span className="fs-six fw-medium n700-color">
                    Regulatory Compliant:{" "}
                    <span className="fs-seven fw-normal">
                      Adhering to monetary policies, making transactions secure
                      and reliable.
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
